import { QueryResult } from '@apollo/client/react';

import { DialogueIcon } from '@treams/treams-icons';
import { FeedbackRequest, FeedbackRequestsQuery } from '@treams/treams-network';
import { CardList } from '@treams/treams-ui';

import IncomingFeedbackCard from './IncomingFeedbackCard';

export default function IncomingFeedbackList(props: {
	query: QueryResult<FeedbackRequestsQuery>;
	userID: string;
	fetchArchived: () => void;
	archivedQuery: QueryResult<FeedbackRequestsQuery>;
}) {
	return (
		<CardList
			translationName="feedback.incoming"
			query={props.query}
			archivedQuery={props.archivedQuery}
			fetchArchived={props.fetchArchived}
			path="user.feedbackRequests"
			icon={<DialogueIcon />}
			renderCard={(item: FeedbackRequest) => (
				<IncomingFeedbackCard key={item.id} userID={props.userID} request={item} />
			)}
			renderSkeleton={() => <IncomingFeedbackCard.Skeleton />}
			groupedByYear
		/>
	);
}
